import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { getCourses } from '../actions/getCourses';

type GetCoursesParams = {
  filter?: string;
  sort?: string;
  orderBy?: string;
  limit?: string;
  offset?: string;
  search?: string;
};

const getCoursesQueryKey = (params: GetCoursesParams) => ['courses', params];

export const getCoursesQueryOptions = (params: GetCoursesParams) =>
  queryOptions({
    queryKey: getCoursesQueryKey(params),
    staleTime: 0, // always fetch fresh data

    placeholderData: keepPreviousData, // don't have 0 rows flash while changing pages/loading next page
    queryFn: async () => {
      const response = await getCourses({
        data: params,
      });

      if (!response.success || response.error) {
        throw new Error(response.error || 'Unknown error');
      }

      return response.data;
    },
  });

export const useGetCourses = (params: GetCoursesParams) =>
  useQuery(
    getCoursesQueryOptions({
      filter: params.filter,
      sort: params.sort,
      orderBy: params.orderBy,
      limit: params.limit,
      offset: params.offset,
      search: params.search,
    })
  );
